.scrollable-area {
  overflow-y: auto;
  overflow-x: hidden;
  
  min-width: 0;  

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: var(--color-bg-primary);
    border-radius: var(--radius-md);
  }

  &::-webkit-scrollbar-thumb {
    background: var(--color-bg-secondary);
    border-radius: var(--radius-md);

    &:hover {
      background: var(--color-bg-secondary-hover);
    }
  }

  &.scrollbar-hidden {
    // For Webkit browsers (Chrome, Safari, Edge)
    &::-webkit-scrollbar {
      display: none;
    }
    // For Firefox
    scrollbar-width: none;
    // For IE/Edge (older versions)
    -ms-overflow-style: none;
  }
}
